module.exports = __webpack_public_path__ + "img/48_17.63fba4a1.png";